import React from "react";
import { LabelValue } from "@Component/Value";
import { Card } from "@/CommonElements/Hajj/Card";
import { useTranslation } from "react-i18next";
import { STACK_4 } from "./PilgrimDetails";

export const PilgrimMakkahData = (props) => {
  const { t } = useTranslation();
  const { isLoading } = props;

  const {
    service_center_number_makkah,
    accommodation_address_makkah,
    locker_number_makkah,
    arrival_date_makkah,
    preliminary_departure_report_number_makkah,
    campaign_name,
    campaign_number,
    group_number,
    group_name,
  } = props;

  const VerticalLabelValue = ({ value, ...props }) => {
    return (
      <LabelValue
        loading={isLoading}
        value={value || "-"}
        direction="vertical"
        {...props}
      />
    );
  };

  return (
    <Card header={<span className="H5">{t("PILGRIM_DATA_MAKKAH")}</span>}>
      <STACK_4>
        {!!campaign_name && (
          <VerticalLabelValue
            label={t("CAMPAIGN_NAME")}
            value={campaign_name}
          />
        )}
        {!!campaign_number && (
          <VerticalLabelValue
            copyValue={campaign_number}
            label={t("CAMPAIGN_NUMBER")}
            value={campaign_number}
          />
        )}
        {!!group_name && (
          <VerticalLabelValue
            copyValue={group_name}
            label={t("GROUP_NAME")}
            value={group_name}
          />
        )}
        {!!group_number && (
          <VerticalLabelValue
            copyValue={group_number}
            label={t("GROUP_NUMBER")}
            value={group_number}
          />
        )}
        <VerticalLabelValue
          copyValue={service_center_number_makkah}
          label={t("SERVICE_CENTER_NUMBER_MAKKAH")}
          value={service_center_number_makkah}
        />
        <VerticalLabelValue
          label={t("ACCOMMODATION_ADDRESS_MAKKAH")}
          value={accommodation_address_makkah}
        />
        <VerticalLabelValue
          copyValue={locker_number_makkah}
          label={t("LOCKER_NUMBER_MAKKAH")}
          value={locker_number_makkah}
        />
        <VerticalLabelValue
          label={t("ARRIVAL_DATE")}
          value={arrival_date_makkah}
        />
        <VerticalLabelValue
          label={t("PRELIMINARY_DEPARTURE_REPORT_NUMBER")}
          value={preliminary_departure_report_number_makkah}
        />
      </STACK_4>
    </Card>
  );
};
